import "./savingsAccountsOffersViewOffersList.scss";
// vendors
import React, { useState } from 'react';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
import PropTypes from "prop-types";
// components
import GenericOfferCard from '../../../../components/offers/UI/genericOfferCard/genericOfferCard';
import ListItemBody from "./components/listItemBody/listItemBody";
import { OKButton } from 'commonsComponents/OKButton';
import SavingsAccountsOffersViewCardModal from "../savingsAccountsOffersViewCardModal/savingsAccountsOffersViewCardModal";
// constants
import {
    SAVINGS_ACCOUNT_HIRING_FLOW_URL,
    SAVINGS_TITLE_MAP,
    SAVINGS_TAGGING_MAP
} from 'constants/eAccountLoan';
const { CONTRACT_BUTTON } = require('constants/tagging');
// utilities
import { recordLinkV2 } from "utilities/tagging";

const SavingsAccountsOffersViewOffersList = ({ offers, isFullRates, history }) => {
    const [selectedCard, setSelectedCard] = useState(null);
    const { offers: offersList, examples, order } = offers;

    const handleCardButtonClick = (card, category) => {
        const eventCategory = SAVINGS_TAGGING_MAP[category];
        const taggingData = {
            categoriaEvento: eventCategory,
            accionEvento: CONTRACT_BUTTON,
            etiquetaEvento: formatText(card.accountName)
        }
        recordLinkV2(taggingData);

        history.push(`${SAVINGS_ACCOUNT_HIRING_FLOW_URL}${card.productId}`);
    }

    const buildCardFooter = (card, category) => (
        <div className="savings-account-offers-view-offers-list__footer-button">
            <OKButton
                modifier="ghost"
                onClick={() => handleCardButtonClick(card, category)}
            >
                <FormattedText value="contractsView-contratar" />
            </OKButton>
        </div>
    );

    const renderSectionTitle = (category) => {
        return (
            <h2 className="savings-account-offers-view-offers-list__sectionTitle">
                {formatText(SAVINGS_TITLE_MAP[category])}
            </h2>
        )
    }

    const renderCards = (cards, category) => (
        cards.map((card, index) => {
            const { accountTerm, accountName, accountTag } = card;
            const term = accountTerm ?
                <FormattedText value="contractsView-installmentValueKey" injectedStrings={[accountTerm]} /> :
                <FormattedText value="savingsAccounts-savingsAccounts_withoutTerm" />
            return (
                <GenericOfferCard
                    key={index}
                    headerSecondaryElement={term}
                    title="savingsAccounts-savingsAccounts_savingAccount"
                    tag={accountTag || undefined}
                    subtitle={accountName}
                    bodyContent={<ListItemBody card={card} isFullRates={isFullRates} onClick={() => setSelectedCard(card)} />}
                    footerContent={buildCardFooter(card, category)}
                />
            )
        }
        ));

    return (
        <div className="savings-account-offers-view-offers-list">
            {order.map((category, index) => (
                <React.Fragment key={index}>
                    {renderSectionTitle(category)}
                    <div className="savings-account-offers-view-offers-list__list-container">
                        {renderCards(offersList[category], category)}
                    </div>
                </React.Fragment>
            ))}
            {selectedCard &&
                <SavingsAccountsOffersViewCardModal
                    card={selectedCard}
                    onClose={() => setSelectedCard(null)}
                    rateExamples={examples}
                />
            }
        </div>
    );
};

SavingsAccountsOffersViewOffersList.propTypes = {
    offers: PropTypes.shape({
        offers: PropTypes.object.isRequired,
        examples: PropTypes.array.isRequired,
    }).isRequired,
    isFullRates: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
};

export default SavingsAccountsOffersViewOffersList;
